import React from "react";
import { Button, StyledText } from "../../../../components/common";
import Smile from "../../../../components/images/smile_imoji.png";
import { BackIcon } from "../../../../components/svgs";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

const ModalOverlay = styled.div`
  position: absolute;
  z-index: 1000;
  top: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
`;

const ModalContent = styled.div`
  position: absolute;
  z-index: 1000;
  width: 100%;
  bottom: 0;
  box-sizing: border-box;
  padding: 20px 20px;
  height: 55%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: white;
  // margin-top: 70%;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
`;

const Header = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 5px;
`;

const CloseButton = styled.div`
  cursor: pointer;
`;

const PledgeModal = ({ onBackDropClick }) => {
  let history = useHistory();

  return (
    <>
      <ModalOverlay onClick={onBackDropClick} />
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <div
          style={{
            width: 50,
            height: 8,
            backgroundColor: "#cbcbcb",
            borderRadius: 10,
          }}
        />
        <Header>
          <CloseButton onClick={onBackDropClick}>
            <BackIcon />
          </CloseButton>
        </Header>

        <img src={Smile} style={{ width: "90px" }} alt="" />
        {/* <PeerTalkIcons /> */}
        <StyledText style={{ fontSize: 20, marginTop: 10, marginBottom: 5 }}>
          Welcome to PeerTalk
        </StyledText>
        <StyledText
          style={{
            textAlign: "center",
            fontFamily: "MTNRegular",
            fontSize: "13px",
            margin: 0,
          }}
          color="#aba9a9"
        >
          Community Rules
        </StyledText>
        <StyledText
          style={{
            textAlign: "center",
            fontFamily: "MTNRegular",
            paddingInline: 15,
            marginBottom: 20,
            marginTop: 5,
          }}
        >
          Always maintain a positive tone, avoid using harsh language, and refrain from sharing personal information such as your name, phone number, or other sensitive details. Stay
          anonymous.
        </StyledText>
        <Button
          style={{ backgroundColor: "#ffcc00", width: "80%" }}
          onClick={() => history.push("/peer_talk/write_story")}
        >
          <StyledText color="#333">I Pledge</StyledText>
        </Button>
      </ModalContent>
    </>
  );
};

export default PledgeModal;
